// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/31330.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-container {
    background: linear-gradient(
        rgba(255, 255, 255, 0.8), 
        rgba(255, 255, 255, 0.8)
      ), 
      url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center center fixed;
    background-size: cover;
    min-height: 100vh; /* Ocupa tota l'alçada de la pantalla */
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 10vh; /* Col·loca el formulari al primer terç */
  }
  
  .card {
    background-color: rgba(255, 255, 255, 0.9); /* Fons lleugerament opac */
    border-radius: 10px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); /* Petita ombra */
    width: 100%;
    max-width: 400px;
  }
  `, "",{"version":3,"sources":["webpack://./src/pages/login.css"],"names":[],"mappings":"AAAA;IACI;;;;2EAI0D;IAC1D,sBAAsB;IACtB,iBAAiB,EAAE,uCAAuC;IAC1D,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,iBAAiB,EAAE,yCAAyC;EAC9D;;EAEA;IACE,0CAA0C,EAAE,2BAA2B;IACvE,mBAAmB;IACnB,wCAAwC,EAAE,iBAAiB;IAC3D,WAAW;IACX,gBAAgB;EAClB","sourcesContent":[".login-container {\r\n    background: linear-gradient(\r\n        rgba(255, 255, 255, 0.8), \r\n        rgba(255, 255, 255, 0.8)\r\n      ), \r\n      url('../images/31330.jpg') no-repeat center center fixed;\r\n    background-size: cover;\r\n    min-height: 100vh; /* Ocupa tota l'alçada de la pantalla */\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    padding-top: 10vh; /* Col·loca el formulari al primer terç */\r\n  }\r\n  \r\n  .card {\r\n    background-color: rgba(255, 255, 255, 0.9); /* Fons lleugerament opac */\r\n    border-radius: 10px;\r\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); /* Petita ombra */\r\n    width: 100%;\r\n    max-width: 400px;\r\n  }\r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
